import { html } from "lit";
var icon_print_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 28">
    <path
      d="M21.198 17.497H7.802l-2.05 10.241h17.495l-2.049-10.241zm-1.332 1.624l1.399 6.992H7.734l1.399-6.992h10.733z" />
    <path
      d="M8.468 5.431v1.625H6.086a.912.912 0 00-.758.406l-.057.098-2.383 4.765h23.223L23.729 7.56a.912.912 0 00-.701-.496l-.114-.008h-2.382V5.431h2.382c.9 0 1.729.478 2.183 1.245l.086.158 2.745 5.491h.31v.621l.503 1.005-.503-.001v6.082a2.536 2.536 0 01-2.37 2.531l-.166.006h-4.48v-1.625h4.48a.911.911 0 00.905-.806l.006-.106V13.95H2.386v6.082a.91.91 0 00.805.905l.106.006h4.481v1.625H3.297a2.536 2.536 0 01-2.53-2.37l-.006-.166.001-6.082H.259l.503-1.004v-.62l.31-.001 2.745-5.491a2.537 2.537 0 012.09-1.396l.179-.006h2.382z" />
    <path
      d="M24.41 15.773a1.243 1.243 0 110 2.485 1.243 1.243 0 010-2.485zm0 .861a.382.382 0 100 .762.382.382 0 000-.762zM21.344.262v10.242H7.655V.261h13.69zM19.72 1.886H9.28v6.992h10.439V1.886z" />
  </svg>
`;
export {
  icon_print_default as default
};
//# sourceMappingURL=icon-print.js.map
